import { atom } from "recoil";

export const getCollapsed = atom({
  key: "getCollapsed",
  default: false,
});
